module.exports = __webpack_public_path__ + "static/media/gc-puzzle-boat-view.b39ab1fb.jpg";